import { gql } from "@outschool/ui-apollo";

export const EnrollmentMeetingPurchaseRecurringQuery = gql`
  query enrollmentMeetingPurchaseRecurringQuery(
    $activityUid: ID!
    $startTime: DateTime!
    $endTime: DateTime!
    $orgTeacherUid: String
    $includeFirstMeeting: Boolean
  ) {
    activity(uid: $activityUid) {
      uid
      canScheduleContinuously(
        startTime: $startTime
        endTime: $endTime
        orgTeacherUid: $orgTeacherUid
      )
      futureEnrollmentMeetingAvailability(
        startTime: $startTime
        endTime: $endTime
        orgTeacherUid: $orgTeacherUid
        includeFirstMeeting: $includeFirstMeeting
      ) {
        startTime
        endTime
        isAvailable
      }
    }
  }
`;
